module.exports = "/_next/static/images/flip-shadow-bottom-7cb0d501ec1f1b4a1d62dadb70dd564c.png";